"use client";

import React from 'react';
import Link from 'next/link';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { GlassContainer } from '@/components/misc/glass-container';
import { cn, containerClasses } from '@/lib/utils';
import { Button } from '@/components/ui/button';

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.8 }
  }
};

export function ContactCTA() {
  return (
    <section 
      className={cn(
        "py-24 relative overflow-hidden",
        "bg-gradient-to-r from-true-blue/10 to-thistle/10"
      )}
    >
      <div className="absolute inset-0 bg-white/40 backdrop-blur-sm" />
      
      <div className={cn(containerClasses, "relative z-10")}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
          className="max-w-4xl mx-auto"
        >
          <GlassContainer intensity="medium" className="text-center">
            <h2 className="text-h2 mb-6">
              Bereit, Ihre Recruiting-Prozesse zu revolutionieren?
            </h2>
            
            <p className="text-body-lg mb-8 max-w-3xl mx-auto">
              Vereinbaren Sie ein unverbindliches Beratungsgespräch mit unseren Experten und erfahren Sie, wie Umynd Ihrem Unternehmen helfen kann, die besten Talente zu finden und zu halten.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
              {/* CTA Card 1: Jobsuchende */}
              <div className="bg-gradient-to-br from-thistle-50 to-thistle-100 p-8 rounded-xl shadow-lg">
                <h3 className="text-h3 text-thistle-dark mb-4">Interessiert an Jobangeboten?</h3>
                <p className="text-body mb-6 min-h-[70px] text-foreground/80">
                  Erstellen Sie Ihr Profil und entdecken Sie maßgeschneiderte Karrierechancen.
                </p>
                <Link href="/contact?preselect=candidate" passHref>
                  <Button variant="secondary" size="lg"> 
                    Profil erstellen <ArrowRight className="ml-2 h-5 w-5" />
                  </Button>
                </Link>
              </div>

              {/* CTA Card 2: Unternehmen */}
              <div className="bg-gradient-to-br from-true-blue-50 to-true-blue-100 p-8 rounded-xl shadow-lg">
                <h3 className="text-h3 text-true-blue mb-4">Sie suchen neue Mitarbeiter?</h3>
                <p className="text-body mb-6 min-h-[70px] text-foreground/80">
                  Sprechen Sie uns an und finden Sie die passenden Talente für Ihr Unternehmen.
                </p>
                <Link href="/contact?preselect=company" passHref>
                  <Button variant="default" size="lg"> 
                    Anfrage senden <ArrowRight className="ml-2 h-5 w-5" />
                  </Button>
                </Link>
              </div>
            </div>
          </GlassContainer>
        </motion.div>
      </div>
    </section>
  );
}